import { Icon } from "@iconify/react";
import { a769, a770,a771 } from "Components/Api/RootApiPath";
import AlertMessage from "Components/Other Functions/AlertMessage";
import ErrorModal from "Components/Other Functions/popup";
import PageLoader from "Components/PageLoader";
import CustomerTable from "Components/support/customervendor/customer";
import useScreenSize from "hooks/useScreenSize";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { customOrderListColumns } from "utils/helpers";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import AdminHeading from "../Heading/AdminHeading";
import { printOrder } from "./CustomOrderPrint";

const CustomOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const allStates = useSelector((state) => state);
  const navigate = useNavigate();
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const isSmallScreen = useScreenSize();

  const handleGetAllOrders = async () => {
    try {
      const requestData = {
        ClientCode: clientCode,
      };
  
      const response = await fetch(a770, { // a769 to a770 updated
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
  
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch orders: ${errorText}`);
      }
  
      const responseData = await response.json();
      console.log("All order List " + JSON.stringify(responseData, null, 2));
  
      // Format orders data for table display
      const formattedOrders = responseData.map((order) => ({
        ...order,
        serialNumber: order.CustomOrderId, // Assuming it's your serial number or order ID
        OrderNo: order.OrderNo, // Assuming `CustomOrderId` is the order number
        CustomerName: `${order?.Customer?.FirstName} ${order?.Customer?.LastName}`,
        Category: order.Category || "N/A", // Handle if Category is null
        Product: order.Product || "N/A", // Handle if Product is null
        Design: order.Design || "N/A", // Handle if Design is null
        Purity: order.Purity || "N/A", // Handle if Purity is null
        GrossWt: order.GrossWt || "0.00", // Handle if GrossWt is null
        StoneWt: order.StoneWt || "0.00", // Handle if StoneWt is null
        DiamondWt: order.DiamondWt || "0.00", // Handle if DiamondWt is null
        NetWt: order.NetWt || "0.00", // Handle if NetWt is null
        Size: order.Size || "N/A", // Handle if Size is null
        Length: order.Length || "N/A", // Handle if Length is null
        Quantity: order.Quantity || "0", // Handle if Quantity is null
        RatePerGram: order.Rate || "0", // Handle if Rate is null
        MakingPerGram: order.Making || "0", // Handle if Making is null
        FixedMaking: order.FixedMaking || "0", // Handle if FixedMaking is null
        FixedWt: order.FixedWt || "0", // Handle if FixedWt is null
        MakingPercentage: order.MakingPercent || "0", // Handle if MakingPercent is null
        DiamondPieces: order.DiamondPieces || "0", // Handle if DiamondPieces is null
        DiamondAmount: order.DiamondAmount || "0", // Handle if DiamondAmount is null
        StoneAmount: order.StoneAmt || "0", // Handle if StoneAmt is null
        ScrewType: order.ScrewType || "N/A", // Handle if ScrewType is null
        Polish: order.Polish || "N/A", // Handle if Polish is null
        Rhodium: order.Rhodium || "N/A", // Handle if Rhodium is null
        SampleWt: order.SampleWt || "0", // Handle if SampleWt is null
        Remarks: order.Remarks || "N/A", // Handle if Remarks is null
        OrderDate: new Date(order.CreatedOn).toLocaleDateString(),
        DeliveryDate: new Date(order.LastUpdated).toLocaleDateString(),
        TotalAmount: order.TotalAmount || "0", // Assuming TotalAmount exists or is calculated
      }));
      
      console.log("Formatted orders:", formattedOrders); 

      setOrders(formattedOrders); // Update the state with the formatted orders
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error(`Failed to fetch orders: ${error.message}`, {
        position: "top-center",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    handleGetAllOrders();
  }, []);

  const fetchOrderById = async (orderId) => {
    console.log("Fetching order with ID:", orderId);
    try {
      const response = await fetch(`${a771}`, { // a770 to a771 updated
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ClientCode: clientCode,
          CustomOrderId: orderId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch order");
      }
      const orderData = await response.json();
      return orderData;
    } catch (error) {
      console.error("Error fetching order:", error);
      toast.error(`Failed to fetch order: ${error.message}`, {
        position: "top-center",
        duration: 3000,
      });
    }
  };

  const handleEditOrder = async (order) => {
    if (!order.CustomOrderId) {
      console.error("CustomOrderId is missing in the order:", order);
      return;
    }
    const orderData = await fetchOrderById(order.CustomOrderId);
    if (orderData) {
      navigate("/custom_order_new", {
        state: { orderData, editStatus: true },
      });
    }
  };

  const handlePrint = async (order) => {
    const orderData = await fetchOrderById(order.CustomOrderId);
    if (orderData) {
      printOrder(orderData);
    }
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <div>
        <AdminHeading />
        {loading && <PageLoader />}
        <ErrorModal
          isOpen={showModal}
          onRequestClose={() => {
            setShowModal(false); // Close the modal
            navigate("/adminhome"); // Redirect to /adminhome
          }}
          onReload={() => {}} // Pass reload function
          message={errorMessage}
        />
        <div className="adminMainBodyBox">
          {showError ? (
            <AlertMessage message={errorMessage} type="error" />
          ) : null}
        </div>
        {!isSmallScreen && (
          <AdminBreadCrump
            title="Custom Order List"
            companyName="Loyalstring"
            module="Transactions"
            page="Custom Order List"
          />
        )}
      </div>

      <div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "end",
            background: "#fff",
            padding: "10px 0px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search..."
              style={{
                border: "1px solid gray",
                borderRadius: "0px",
                borderBottomLeftRadius: "8px",
                borderTopLeftRadius: "8px",
                height: "100%",
              }}
            />
            <Icon
              style={{
                fontSize: "20px",
                padding: "7px",
                background: "#0077D4",
                color: "#fff",
                height: "20px",
                width: "20px",
                borderBottomRightRadius: "8px",
                borderTopRightRadius: "8px",
              }}
              icon="mdi:magnify"
            />
          </div>

          <Icon
            style={{
              fontSize: "28px ",
              color: "#0077d4",
              cursor: "pointer",
            }}
            icon="bx:export"
          />

          <button>
            <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
            Print
          </button>
          <button
            onClick={() => navigate("/custom_order_new")}
            style={{ margin: 0 }}
          >
            New
            <Icon icon="mdi:plus" width="24" height="24" />
          </button>
        </div>

        <CustomerTable
          columns={customOrderListColumns}
          allCategories={orders?.length ? orders : []}
          handleEditData={handleEditOrder}
          handlePrint={handlePrint}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
        />
      </div>
    </>
  );
};

export default CustomOrderList;
